import type { LocationQuery, LocationQueryRaw } from 'vue-router';

/** 兼容历史 project_id，并统一读取为 Canvas 项目 ID。 */
export function readCanvasProjectId(query: Record<string, unknown>): string {
  const raw = query.projectId ?? query.project_id;
  if (Array.isArray(raw)) return String(raw[0] ?? '');
  return typeof raw === 'string' ? raw : '';
}

/** 保留页面其他查询参数，只把项目参数规范化为 projectId。 */
export function buildCanvasProjectQuery(
  query: LocationQuery,
  projectId: string,
): LocationQueryRaw {
  const nextQuery: LocationQueryRaw = { ...query, projectId };
  delete nextQuery.project_id;
  return nextQuery;
}

export function buildLocalizedCanvasPath(
  locale: string,
  projectId: string,
): string {
  const localePrefix = locale === 'en' ? '' : `/${locale}`;
  return `${localePrefix}/canvas?projectId=${encodeURIComponent(projectId)}`;
}
